<template>
  <div
    class="modal fade"
    id="DeliveryAddressPDPModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            id="exampleModalLabel"
												data-test="deliveryAddressPopUpHeading"
          >
            Select Delivery Address
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click.prevent="closeAddressPopUp(false)"
												data-test="deliveryAddressPopUpCloseBtn"
												id="deliveryAddressPopUpCloseBtn"
          >
            <span aria-hidden="true"
																		data-test="deliveryAddressPopUpCloseSpan"
																		id="deliveryAddressPopUpCloseSpan">
              &times;
            </span>
          </button>
        </div>

        <div class="modal-body">
          <div v-if="customerAddress.length > 0">
            <address-list-template
              v-for="address in customerAddress"
              :key="address.addressLine1"
              :address="address"
              :data="deliveryAddress"
              :showInputRadio="true"
              :show-edit="false"
              :show-delete="false"
            />
          </div>
          <button
            type="button"
            name=""
            id="delivery-addrss-continue-btn"
            class="btn btn-primary blue-btn mt-4"
            style="float: right;"
            data-dismiss="modal"
            @click.prevent="closeAddressPopUp(true)"
												data-test="deliveryAddressPopUpContinueBtn"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AddressListTemplate from '../../../../widgets/user/AddressListTemplate'
import { orderApi } from '../../../../../services/ApiServices/orderApi'

export default {
	components: { AddressListTemplate },
	name: 'delivery-address-popup',
	props: {
		customerAddress: {
			type: Array,
			default: () => []
		},
		product: {
			type: Object,
			default: () => { }
		}
	},
	mounted () {
		if (this.customerAddress.length > 0) {
			this.deliveryAddress.selectedAddress = this.customerAddress[0]
		}
	},
	data () {
		return {
			deliveryAddress: {
				selectedAddress: {}
			}
		}
	},
	methods: {
		...mapActions('user', ['setAddressData', 'setSelectedAddressIdData', 'setSelectedAddressData', 'deleteAddressData']),
		closeAddressPopUp (vendorSelected) {
			if (this.product.vendor_IDs) {
				orderApi.checkVendorAvailability().then(() => {
					this.$emit('closeAddressPopUp', vendorSelected)
				})
			}
			this.$emit('closeAddressPopUp', vendorSelected)
		}
	},
	watch: {
		customerAddress () {
			if (this.customerAddress.length > 0) {
				this.deliveryAddress.selectedAddress = this.customerAddress[0]
			}
		},
		deliveryAddress: {
			handler (val) {
				this.setSelectedAddressData(val.selectedAddress)
				this.setSelectedAddressIdData(val.selectedAddress.addressId)
			},
			deep: true
		},
		selectedAddress () {
			this.setSelectedAddressData(this.deliveryAddress.selectedAddress)
			this.setSelectedAddressIdData(this.deliveryAddress.selectedAddress.addressId)
		}
	}
}
</script>

<style scoped>
.field-tip {
  display: block;
  position: absolute;
}

.tip-content {
  overflow-y: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 150px;
  /*overflow:visible;*/
  background: #ffffff;
  display: block;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.2);
}
</style>
